type CurrencyProps = {
  value: number;
  fractionDigits?: number;
};

export const formatCurrency = ({
  value,
  fractionDigits = 2,
}: CurrencyProps) => {
  return Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
    minimumFractionDigits: fractionDigits,
  }).format(value);
};

export const formatStringCurrency = (value: string) => {
  return `R$ ${value
    .replace('.', ',')
    .replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, '.')}`;
};
